<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.crime_law')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <card shadow class="card-profile mt--100 card_radius_no" no-body>
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                                        class="news_title">{{$t('crime_law.crime_title')}}</span></div>
                            </div>
                            <div class="mt-3 py-3 text-center">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <el-collapse v-model="activeName" accordion>
                                          <el-collapse-item :title="$t('crime_law.crime_yil9')" name="1"
                                                            class="text-center">
                                            <p style="text-align: justify;">{{$t('crime_law.crime_yil9_text')}}</p>
                                          </el-collapse-item>
                                          <el-collapse-item :title="$t('crime_law.crime_yil8')" name="2"
                                                            class="text-center">
                                            <p style="text-align: justify;">{{$t('crime_law.crime_yil8_text')}}</p>
                                          </el-collapse-item>
                                            <el-collapse-item :title="$t('crime_law.crime_yil7')" name="3"
                                                              class="text-center">
                                                <p style="text-align: justify;">{{$t('crime_law.crime_yil7_text')}}</p>
                                            </el-collapse-item>
                                            <el-collapse-item :title="$t('crime_law.crime_yil6')" name="4"
                                                              class="text-center">
                                                <p style="text-align: justify;">{{$t('crime_law.crime_yil6_text')}}</p>
                                            </el-collapse-item>
<!--                                            <el-collapse-item :title="$t('crime_law.crime_yil')" name="3"-->
<!--                                                              class="text-center">-->
<!--                                                <p style="text-align: justify;">{{$t('crime_law.crime_yil_text')}}</p>-->
<!--                                            </el-collapse-item>-->
<!--                                            <el-collapse-item :title="$t('crime_law.crime_yil2')" name="4"-->
<!--                                                              class="text-center">-->
<!--                                                <p style="text-align: justify;">{{$t('crime_law.crime_yil2_text')}}</p>-->
<!--                                            </el-collapse-item>-->
<!--                                            <el-collapse-item :title="$t('crime_law.crime_yil3')" name="5"-->
<!--                                                              class="text-center">-->
<!--                                                <p style="text-align: justify;">{{$t('crime_law.crime_yil3_text')}}</p>-->
<!--                                            </el-collapse-item>-->
                                        </el-collapse>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style scoped>
    /deep/ .el-collapse-item__header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 48px;
        line-height: initial !important;
        background-color: #fff;
        color: #303133;
        cursor: pointer;
        border-bottom: 1px solid #EBEEF5;
        font-size: 13px;
        font-weight: 500;
        -webkit-transition: border-bottom-color .3s;
        transition: border-bottom-color .3s;
        outline: none;
    }
</style>
